import axios from "../axios/AxiosInstance";

export const toAcompteRow = (acompte) => ({
  id: acompte._id,
  candidateId: acompte.candidate?._id || acompte.candidate,
  name: acompte.name,
  requestedAmount: Number(acompte.askedAmount),
  paidAmount: Number(acompte.validatedAmount) > 0 ? Number(acompte.validatedAmount) : null,
  paymentDate: acompte.paymentDate,
  reason: acompte.motif || "",
  source: acompte.provenance,
  status: acompte.status,
  author: acompte.createdByName || "",
  createdAt: acompte.createdAt,
});

export async function listAcomptes() {
  const { data } = await axios.get("acompte/freelance");
  return Array.isArray(data) ? data.map(toAcompteRow) : [];
}

export async function createAcompte({ candidateId, amount, paymentDate, reason }) {
  const { data } = await axios.post("acompte/freelance", {
    candidateId,
    amount: Number(amount),
    paymentDate,
    motif: reason?.trim() || "",
  });
  return toAcompteRow(data);
}
